<template>
  <h4>Portfolio <span>{{ subtitle }}</span></h4>
</template>

<script setup>
defineProps({subtitle: {type: String, required: true}});
</script>

<style scoped>
span {
  margin-left: 0.3em;
  font-size: 0.75em;
  font-weight: 200;
  /* just under "less subtle", a fifth of the way toward the affiliations' colour (both themes) */
  color: color-mix(in srgb, var(--text-color-less-subtle) 80%, var(--text-color-subtle));
}
</style>
